import { render, staticRenderFns } from "./BrandsPicker.vue?vue&type=template&id=6553e35f"
import script from "./BrandsPicker.vue?vue&type=script&lang=js"
export * from "./BrandsPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports